import axios from "axios";
import { API } from "../config";

const path = "/auditoria";

export function urlLogoServico(id) {
  return API + `/servico-acolhimento/logo/${id}`;
}

function campoComSubgrupo(aba, subgrupo, campo) {
  const distinto =
    subgrupo &&
    subgrupo.trim().toLowerCase() !== (aba || "").trim().toLowerCase();
  return distinto ? `${subgrupo} - ${campo}` : campo;
}

// Alguns campos (ex.: Restrições de Gênero) chegam como array serializado em
// string — ex.: `["Não Declarado","Masculino","Feminino"]`. Exibe como lista
// separada por vírgula, igual já é feito na ficha do Serviço de Acolhimento.
export function formatarValorAuditoria(valor) {
  if (typeof valor !== "string") return valor;

  const texto = valor.trim();
  if (!texto.startsWith("[") || !texto.endsWith("]")) return valor;

  try {
    const lista = JSON.parse(texto);
    if (!Array.isArray(lista)) return valor;
    return lista.join(", ");
  } catch {
    return valor;
  }
}

export function achatarEventos(eventos) {
  // Um evento pode vir dividido em mais de um bloco (mesmo id) para preservar
  // a ordenação global do backend — o índice do bloco mantém a chave única.
  return (eventos || []).flatMap((evento, indiceBloco) =>
    (evento.campos || []).map((campo, indiceCampo) => ({
      key: `${evento.id}-${indiceBloco}-${indiceCampo}`,
      dataHora: evento.dataHora,
      usuario: evento.usuario,
      login: evento.login,
      perfil: evento.perfil,
      orgao: evento.orgao,
      acao: evento.acao,
      aba: evento.aba,
      campo: campo.campo,
      subgrupoInformacao: campo.subgrupoInformacao,
      campoExibicao: campoComSubgrupo(
        evento.aba,
        campo.subgrupoInformacao,
        campo.campo,
      ),
      valorAnterior: campo.valorAnterior,
      valorNovo: campo.valorNovo,
      identificadorLinha: campo.identificadorLinha,
      referenciaRegistro: campo.referenciaRegistro,
    })),
  );
}

const paramsFiltros = (filters = {}) => ({
  nomeServico: filters.nomeServico || undefined,
  nomeCrianca: filters.nomeCrianca || undefined,
  idServicoAcolhimento: filters.idServicoAcolhimento || undefined,
  periodoInicial: filters.periodoInicial || undefined,
  periodoFinal: filters.periodoFinal || undefined,
  login: filters.login || undefined,
  perfil: filters.perfil || undefined,
  grupoCampo: filters.grupoCampo || undefined,
  acao: filters.acao || undefined,
  situacao: filters.situacao || undefined,
});

class AuditoriaService {
  // Catálogo: usuarios, perfis, gruposCampos, acoes, servicos.
  // visao ("SERVICO" | "CRIANCA") filtra os gruposCampos; sem ela a API
  // devolve a união dos dois catálogos.
  buscarCatalogoFiltros(visao) {
    return axios.get(API + path + "/filtros", { params: { visao } });
  }

  // visao: "SERVICO" | "CRIANCA"
  pesquisar(visao, filters = {}, page = 0, size = 10, sortField, sortType) {
    return axios.get(API + path + "/pesquisar", {
      params: {
        visao,
        ...paramsFiltros(filters),
        page,
        size,
        sortField,
        sortType,
      },
    });
  }

  buscarDetalheServico(
    id,
    filters = {},
    page = 0,
    size = 10,
    sortField,
    sortType,
  ) {
    return axios.get(API + path + `/servico/${id}`, {
      params: { ...paramsFiltros(filters), page, size, sortField, sortType },
    });
  }

  buscarDetalheCrianca(
    id,
    filters = {},
    page = 0,
    size = 10,
    sortField,
    sortType,
  ) {
    return axios.get(API + path + `/crianca/${id}`, {
      params: { ...paramsFiltros(filters), page, size, sortField, sortType },
    });
  }

  buscarRelatorioServico(id, filters = {}) {
    return axios.get(API + path + `/servico/${id}/relatorio`, {
      params: paramsFiltros(filters),
    });
  }

  buscarRelatorioCrianca(id, filters = {}) {
    return axios.get(API + path + `/crianca/${id}/relatorio`, {
      params: paramsFiltros(filters),
    });
  }
}

const auditoriaService = new AuditoriaService();

export default auditoriaService;
